<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="text-xs-center">
        <v-dialog
                @keydown.esc="closeInformationDialog"
                max-width="800"
                persistent
                v-model="$store.getters.informationDialog"
        >
            <v-card>
                <v-card-title
                        class="headline secondary white--text justify-center"
                        primary-title>
                    Στοιχεία Παραλαβής από Φοιτητή
                </v-card-title>

                <v-card-text>
                    <v-layout align-center fill-height justify-space-around row>
                        <v-card>
                            <v-card-title>
                                <v-icon class="mr-2">
                                    person
                                </v-icon>
                                Στοιχεία Φοιτητή
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-list dense v-if="exchangeStudentData.student">
                                <v-list-tile>
                                    <v-list-tile-content><b>'Ονομα :</b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">{{exchangeStudentData.student.firstname}}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content><b>Επώνυμο: </b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">{{exchangeStudentData.student.lastname}}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content><b>E-mail Επικοινωνίας: </b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        {{exchangeStudentData.student.personalEmail}}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content><b>Τηλέφωνο Επικοινωνίας: </b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">{{exchangeStudentData.student.mobile}}
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>

                            <v-divider></v-divider>
                            <v-card-title>
                                <v-icon class="mr-2">
                                    format_list_bulleted
                                </v-icon>
                                Στοιχεία
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-list dense>
                                <v-list-tile>
                                    <v-list-tile-content><b>Μονάδες:</b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">{{utils.getCredit($store.getters.bookExchange, null)}}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content><b>Ημερομηνία Επιλογής: </b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        {{exchangeStudentData.exchangeDestinationDateSelected}}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content><b>Κωδικός ανταλλαγής: </b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        <v-btn  v-if="!this.codeflag"
                                                @click="exchangePassword"
                                                color="info" outline round small
                                                :disabled="loading4"
                                                :loading="loading4">
                                            Πατήστε για τον κωδικό ανταλλαγής
                                            <template slot="loader">
                                                <span class="custom-loader">
                                                  <v-icon light>cached</v-icon>
                                                </span>
                                            </template>
                                        </v-btn>
                                        <!--<v-btn @click="exchangePassword" color="info" outline round small-->
                                               <!--v-if="!this.codeflag">Πατήστε για τον κωδικό ανταλλαγής-->
                                        <!--</v-btn>-->
                                        <v-list-tile-content class="align-end" v-if="this.codeflag">
                                            <b>{{responseCode}}</b></v-list-tile-content>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile>
                                    <v-list-tile-content class="mt-2">{{this.distPointInfo.msg1}}</v-list-tile-content>
                                </v-list-tile>
                                <v-divider class="mt-2 mb-2"></v-divider>
                                <v-list-tile>
                                    <v-list-tile-content><b>
                                        <i>

                                                {{this.distPointInfo.msg2}}

                                        </i>
                                    </b>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-card>

                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click="closeInformationDialog"
                            color="primary darken-0"
                            >
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>

    import requests from "../../requests";
    import utils from "../../utilities";


    export default {
        name: "InformationExchange",
        data() {
            return {
                utils,
                loader: null,
                loading4: false,
                codeflag: false,
                code: '',
                distPointInfo: {
                    address: 'Π. ΡΑΛΛΗ KAI ΘΗΒΩΝ 250',
                    postalCode: '12244',
                    email: 'dianomipada2@gmail.com',
                    fax: '2102125456523',
                    mobilePhone: '698745413165',
                    phone: '210254645165',
                    name: '210254645165',
                    courier: 'ACS',
                    point: 'Πατήστε Εδώ',
                    units: '12,42',
                    date: '05/04/2019',
                    msg1: 'Κατά την παραλαβή του συγγράμματος, θα πρέπει να δώσετε στον παραπάνω φοιτητή τον ειδικό 8-ψήφιο κωδικό ανταλλαγής.',
                    msg2: 'Η ανταλλαγή θα πρέπει να ολοκληρωθεί μέσα σε 5 ημέρες από την Ημερομηνία Επιλογής που αναγράφεται παραπάνω. Μετά το πέρας της διορίας, η επιλογή θα ακυρωθεί αυτόματα.'

                }
            }
        },
        methods: {
            closeInformationDialog() {
                this.$store.commit('setInformationDialog', false);
                this.codeflag = false;
            },
            callBuckSuccessGetPin(response) {
                this.code = response.dstPIN;
                this.codeflag = true;
                this.loading4 = false;
            },
            exchangePassword() {
                this.loading4 = true;
                requests.getPin(this.exchangeStudentData.exchangeDestinationId, this.callBuckSuccessGetPin);
            }
        },
        computed: {
            exchangeStudentData: function () {
                return this.$store.getters.exchangeStudentData
            },
            responseCode: function () {
                return this.code;
            }
        }
    }
</script>

<style>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>